import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Loading = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="loading icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2161 4.54106C8.63187 4.81267 6.49138 6.36464 5.36059 8.5096C4.84547 9.48671 3.63579 9.86122 2.65869 9.34611C1.68159 8.83099 1.30707 7.62131 1.82218 6.64421C3.5489 3.36885 6.83071 0.979943 10.798 0.562968C14.7652 0.145992 18.472 1.80037 20.842 4.64515C21.549 5.4938 21.4341 6.75492 20.5855 7.46193C19.7368 8.16893 18.4757 8.05411 17.7687 7.20546C16.2167 5.34247 13.8003 4.26944 11.2161 4.54106ZM3.41459 16.538C4.26324 15.831 5.52436 15.9458 6.23137 16.7945C7.78341 18.6575 10.1998 19.7305 12.784 19.4589C15.3682 19.1873 17.5087 17.6353 18.6395 15.4903C19.1546 14.5132 20.3643 14.1387 21.3414 14.6538C22.3185 15.1689 22.693 16.3786 22.1779 17.3557C20.4512 20.6311 17.1694 23.02 13.2021 23.437C9.23486 23.8539 5.52809 22.1996 3.15812 19.3548C2.45111 18.5061 2.56594 17.245 3.41459 16.538Z"
    />
    <path
      className={pathClass}
      d="M22.4591 9.15754L23.1649 4.13583C23.2889 3.25359 22.2843 2.66186 21.5728 3.19802L15.8453 7.51398C15.1338 8.05014 15.4257 9.17889 16.308 9.30288L21.3297 10.0086C21.8766 10.0855 22.3823 9.70445 22.4591 9.15754Z"
    />
    <path
      className={pathClass}
      d="M1.54056 14.8389L0.834806 19.8606C0.710816 20.7428 1.71538 21.3346 2.42689 20.7984L8.15436 16.4824C8.86587 15.9463 8.57395 14.8175 7.69172 14.6935L2.67 13.9878C2.12309 13.9109 1.61743 14.292 1.54056 14.8389Z"
    />
  </svg>
)
